import React from 'react';
import PropTypes from 'prop-types';
import { Button, InlineLoading } from 'carbon-components-react';

const ControlButton: React.FC<Props> = ({
  isEmpty,
  isEditMode,
  updateState,
  aoiType,
  disabledSave,
  onClickEdit,
  onClickUpload,
  onClickBoundary,
  onClickRevert,
  onClickSave
}) => {
  return (
    <div className={`aoi-details-control${isEmpty ? '--empty' : ''}`}>
      {!isEditMode && (
        <>
          <Button
            kind={isEmpty ? 'ghost' : 'tertiary'}
            size="field"
            onClick={onClickEdit}
          >
            {isEmpty || aoiType !== 'DRAW' ? 'Draw AOI' : 'Edit AOI'}
          </Button>
          <Button kind="ghost" size="field" onClick={onClickUpload}>
            Upload AOI
          </Button>
          <Button kind="ghost" size="field" onClick={onClickBoundary}>
            Use LGA boundary
          </Button>
        </>
      )}

      {isEditMode && updateState !== 'processing' && (
        <>
          <Button kind="ghost" size="field" onClick={onClickRevert}>
            Revert
          </Button>
          <Button
            kind="primary"
            size="field"
            onClick={onClickSave}
            disabled={disabledSave}
          >
            Save AOI
          </Button>
        </>
      )}
      {isEditMode && updateState === 'processing' && (
        <InlineLoading description="Saving area of interest" />
      )}
    </div>
  );
};

const propTypes = {
  isEmpty: PropTypes.bool,
  isEditMode: PropTypes.bool,
  updateState: PropTypes.string,
  aoiType: PropTypes.string,
  disabledSave: PropTypes.bool,
  onClickEdit: PropTypes.func,
  onClickUpload: PropTypes.func,
  onClickBoundary: PropTypes.func,
  onClickRevert: PropTypes.func,
  onClickSave: PropTypes.func
};

type Props = PropTypes.InferProps<typeof propTypes>;

ControlButton.propTypes = propTypes;

ControlButton.defaultProps = {
  isEmpty: true,
  isEditMode: false,
  updateState: 'initial',
  disabledSave: true
};

ControlButton.displayName = 'AoiControlButton';

export default React.memo(ControlButton);
